import { httpClient, setResponseType } from '@/app/shared/http-service';
import { apiGlobalConstants } from '../config';

const URL = apiGlobalConstants.log;

const fetchAllLogs = (page = null, excel = false, notificaciones = false) => {
  const params = new URLSearchParams();
  if (page != null) params.append('page', page);
  if (excel) params.append('to_excel', 'true');
  if (notificaciones) params.append('notificaciones', '1');

  return httpClient.get(`${URL}?${params.toString()}`).then(res => res.data);
};

const getLogsPedido = (idPedido) => {
  return httpClient.get(`${URL}-pedido/${idPedido}`).then(res => res.data);
}

const getLogsCliente = (idCliente) => {
  return httpClient.get(`${URL}-cliente/${idCliente}`).then(res => res.data)
}

const fetchLogsComentarios = () => {
  return httpClient.get(`${URL}-comentarios`).then(res => res.data);
}

const downloadExcel = (modelo, filename) => {
  setResponseType('blob'); // arraybuffer
  return httpClient.get(`${URL}/to-excel?name=${filename}`).then(res => {
    setResponseType('json');
    return res
  });
};


export {
  fetchAllLogs,
  getLogsPedido,
  getLogsCliente,
  downloadExcel,
  fetchLogsComentarios
}
